
import Assets from "./components/assets";

import Scene from "./components/logo/scene"
import MenuScene from "./components/menu/scene"
import Navigation from "./components/navigation/index"
import Menu from "./components/menu/menu"
import Carousel from "./components/carousel"
// import Client from "./components/client"
import Background from "./components/background/scene"
import Title from "./components/title"
import ProjectsSelection from "./components/projects-selection"
import CallToAction from "./components/call-to-action"
import HomeHeroCover from "./components/home-hero-cover"
import Figures from "./components/figures"
import LinkToCredits from "./components/link-to-credits"
import BatchAnimation from "./components/batch-animation"
import LineBreaks from "./components/line-breaks"


export default class App {
  components = [];
  constructor() {
    Assets.initialize()
    Assets.scheduleMenuMedia()


    const $footer = document.body.querySelector("footer")
    if ($footer) {
      const footerScene = document.createElement("div");
      footerScene.classList.add("fullscreen")
      $footer.prepend(footerScene)
      this.footerScene = new Scene({
        el:footerScene
      })
    }

    this.menuScene = new MenuScene({ el: document.body.querySelector(".cinetic-creative-core-menu") })
    this.menu = new Menu({ el: document.body, layer: this.menuScene })

    const animatedBatch = new BatchAnimation({el: document.body})
    animatedBatch.apply()
    
    new Navigation({
      menu: this.menu,
      footerScene: this.footerScene,
      callback: (container) => {
        this.bindComponents(container)
      },
      leaveCallback: (container) => {
        this.unbindComponents()
      }
    })



    this.bindComponents(document.body)

    if (window.innerWidth > 768) {
      this.setLogoAnimation(document.body)
    }

  }
  bindComponents(container) {
    // First: swap hidden <br> for real spaces on phones, before any text is split.
    this.components.push(new LineBreaks({ el: container }))

    const homeHeroCover = container.querySelector(".home-hero-cover")
    if (homeHeroCover) {
      this.components.push(new HomeHeroCover({
        el: homeHeroCover,
        title: container.querySelector(".wp-block-cinetic-creatives-blocks-grid.fullscreen > .wp-block-cinetic-creatives-blocks-title")
      }))
    }

    const $carousels = container.querySelectorAll("[data-mode=\"carousel\"]")
    $carousels.forEach((el) => {
      this.components.push(new Carousel({el}))
    })

    const $backgrounds = container.querySelectorAll(".background-scene-holder")
    $backgrounds.forEach((el) => {
      this.components.push(new Background({el}))
    })

    const $titles = container.querySelectorAll(".wp-block-cinetic-creatives-blocks-grid > .wp-block-cinetic-creatives-blocks-title")
    $titles.forEach((el) => {
      this.components.push(new Title({el}))
    })

    gsap.set(".wp-block-cinetic-creatives-blocks-title", {
      clearProps: "opacity"
    })


    // const $clients = container.querySelectorAll(".wp-block-cinetic-creatives-blocks-clients")
    // $clients.forEach((el) => {
    //   this.components.push(new Client({el}))
    // })

    const $projectsSelection = container.querySelectorAll(".wp-block-cinetic-creatives-blocks-projects-selection")
    $projectsSelection.forEach((el) => {
      this.components.push(new ProjectsSelection({el, container }))
    })

    const $callToActions = container.querySelectorAll(".wp-block-cinetic-creatives-blocks-call-to-action")
    $callToActions.forEach((el) => {
      this.components.push(new CallToAction({el}))
    })

    const $figures = container.querySelectorAll("figure")
    $figures.forEach((el) => {
      this.components.push(new Figures({el}))
    })

    
    const $projectInfos = container.querySelectorAll(".wp-block-cinetic-creatives-blocks-project-info")
    $projectInfos.forEach((el) => {
      this.components.push(new LinkToCredits({ el, container }))
    })


    const $tabNav = container.querySelector(".wp-block-cinetic-creatives-blocks-tab-nav, .tab-nav");
    // Only listings fade the bar (projects page with its posts block, Cinema bar).
    // The About/Services switcher sits early in the About page: the same fade
    // hid it almost at once, so it is left alone (client, 2026-10-08).
    const isListing = $tabNav && ($tabNav.classList.contains("tab-nav") || container.querySelector(".wp-block-cinetic-creatives-blocks-posts"))

    if ($tabNav && isListing) {
      const animation = new gsap.timeline({ paused: true })
      animation.to( container.querySelector(".wp-block-cinetic-creatives-blocks-tab-nav, .tab-nav"), {
          autoAlpha: 0,
      })
      // Fade the bar out when the end of the project list (the block right
      // after the bar) reaches the bottom of the screen, so the last link and
      // the pagination are never left under it.
      // On the Cinema page the bar is appended after the content: use the
      // block before it as the end of the list.
      const listBlock = $tabNav.nextElementSibling || $tabNav.previousElementSibling || container.querySelector(".wp-block-post-content > :last-child")
      this.st = ScrollTrigger.create({
          trigger: listBlock,
          // the list keeps ~110px of padding under its last row (layout-fixes.scss)
          start: 'bottom bottom+=110',
          scrub: false,
          toggleActions: "play restart play reverse",
          markers: false,
          animation
      });
    }
  }
  unbindComponents() {
      this.components.forEach(component => {
        if ("dispose" in component) component.dispose()
      })
  }
  setLogoAnimation(container) {
    const figure = container.querySelector(".is-style-logo-home")
    const originalImage = figure.querySelector("img")
    const animatedLogo = document.createElement('div');
    animatedLogo.classList.add("animated-logo")
    const sprite = document.createElement('img');
    sprite.src = '/wp-content/themes/cinetic/assets/images/spritesheet-big.png';
    animatedLogo.appendChild(sprite)
    sprite.onload = () => {
      originalImage.style.opacity = 0
    }

    figure.querySelector("a").appendChild(animatedLogo)
    
    const timeline = new gsap.timeline({ paused: true })
    timeline.to(sprite, {      
        y: -128 * 41,
        ease: "steps(41)", 
        duration: 1.4,
      }
    )

    timeline.seek(1.4)

    figure.addEventListener("mouseenter", () => {
        if (!timeline.isActive()) {
            timeline.tweenFromTo(0, 0.7)
        }
    })

    figure.addEventListener("mouseleave", () => {
        if (!timeline.isActive()) {
            timeline.tweenTo(1.4)
        }
    })
  }
}